import { LegacyIcon } from '@gonfalon/icons/LegacyIcon';
import type { LegacyIconProps } from '@gonfalon/icons/types';
import cx from 'clsx';
import FlutterSvg from 'devicon/icons/flutter/flutter-plain.svg';

export const Flutter = ({ className, size, ...props }: LegacyIconProps) => (
  <LegacyIcon name="lang-flutter" className={cx('sdkIcon', className)} size={size} {...props}>
    <FlutterSvg />
  </LegacyIcon>
);
